//#region Charts

var chartHelpers = {
    zoomDirections: {
        in: 10e2,
        out: -10e2
    },
    panXDirections: {
        left: 10e2,
        right: -10e2
    },
    intervalHolder: null,
    zoom($target, direction) {
        let event = this.createZoomEvent(direction)
        $target[0].dispatchEvent(event)
        //setTimeout(() => {
        //    for (let i = 0; i < 3; i++){
        //
        //        let resp = $target[0].dispatchEvent(event)
        //        console.log(i + ' ' + resp)
        //    }
        //}, 1);
    },
    panX(canvas, panXDirection) {
        let instance = this.getChartInstance(canvas)

        if (panXDirection == chartHelpers.panXDirections.left) {
            let firstVisibleLabel = instance.scales["x-axis-0"].min
            let firstAbsoluteLabel = instance.data.labels[0]

            if (firstAbsoluteLabel == firstVisibleLabel) {
                return false
            }

        } else if (panXDirection == chartHelpers.panXDirections.right) {
            let absoluteLabelsLength = instance.data.labels.length

            let lastVisibleLabel = instance.scales["x-axis-0"].max
            let lastAbsoluteLabel = instance.data.labels[absoluteLabelsLength - 1]

            if (lastVisibleLabel == lastAbsoluteLabel) {
                return false
            }
        } else {
            throw console.error('You need to specify panX direction.')
            return false
        }

        let e = {
            deltaX: panXDirection,
            deltaY: 0
        }
        instance._mc.handlers.panstart[0](e)
    },
    resetZoom(canvas) {
        let instance = this.getChartInstance(canvas)
        instance.resetZoom()
    },
    createZoomEvent(direction) {
        let e = document.createEvent('MouseEvents')
        e.initEvent('wheel', true, true)

        if (direction == this.zoomDirections.in) {
            e.deltaY = -10;
        } else if (direction == this.zoomDirections.out) {
            e.deltaY = 10;
        } else {
            throw console.error('You need to specify zoom direction.')
            return false
        }
        return e
    },
    getChartInstance(canvas) {
        let hehe = {}
        Chart.helpers.each(Chart.instances, function (instance) {
            if (instance.chart.canvas == canvas) {
                hehe = instance
            }
        })
        return hehe
    },
    getOrCreateLegendList(chart, id){
        const legendContainer = document.getElementById(id);
        let listContainer = legendContainer.querySelector('ul');

        if (!listContainer) {
          listContainer = document.createElement('ul');
          listContainer.style.display = 'flex';
          listContainer.style.flexDirection = 'column';
          listContainer.style.margin = 0;
          listContainer.style.padding = 0;
          listContainer.style.gap = '0.3rem';

          legendContainer.appendChild(listContainer);
        }

        return listContainer;
      }
}

$(document).on('mousedown', '.canvas-zoom-in, .canvas-zoom-out', function () {
    let $btn = $(this)
    let $target = $($btn.data('target'))
    let direction = $btn.hasClass('canvas-zoom-in') ? chartHelpers.zoomDirections.in : chartHelpers.zoomDirections.out

    chartHelpers.intervalHolder = setInterval(function () {
        chartHelpers.zoom($target, direction)
    }, 25)
})
$(document).on('mousedown', '.canvas-pan-left, .canvas-pan-right', function () {
    let $btn = $(this)
    let direction = $btn.hasClass('canvas-pan-left') ? chartHelpers.panXDirections.left : chartHelpers.panXDirections.right
    let canvas = $($btn.data('target'))[0]

    chartHelpers.intervalHolder = setInterval(function () {
        chartHelpers.panX(canvas, direction)
    }, 100)
})
$(document).on('click', '.canvas-zoom-in, .canvas-zoom-out', function () {
    let $btn = $(this)
    let $target = $($btn.data('target'))
    let direction = $btn.hasClass('canvas-zoom-in') ? chartHelpers.zoomDirections.in : chartHelpers.zoomDirections.out

    for (let i = 0; i < 3; i++) {
        chartHelpers.zoom($target, direction)
    }
})
$(document).on('mouseup mouseleave', '.canvas-zoom-in, .canvas-zoom-out, .canvas-pan-left, .canvas-pan-right', function () {
    clearInterval(chartHelpers.intervalHolder)
})
$(document).on('click', '.canvas-pan-left, .canvas-pan-right', function () {
    let $btn = $(this)
    let direction = $btn.hasClass('canvas-pan-left') ? chartHelpers.panXDirections.left : chartHelpers.panXDirections.right
    let canvas = $($btn.data('target'))[0]

    chartHelpers.panX(canvas, direction)
})
$(document).on('click', '.canvas-zoom-reset', function () {
    let $btn = $(this)
    let canvas = $($btn.data('target'))[0]
    chartHelpers.resetZoom(canvas)
})

//#endregion Charts